import { useMutation } from '@tanstack/react-query'

import { userKeys } from '@/hooks/user-query-keys'
import { RenovarTokenService } from '@/http/renovar-token.service'

export const useRefreshToken = () => {
  return useMutation({
    mutationKey: userKeys.refresh(),
    mutationFn: async () => new RenovarTokenService().execute(),
  })
}
